import { createContext, useContext } from 'react';

/**
 * Layout context — lets inner pages ask AppShell to open the
 * sidebar drawer on mobile without prop-drilling through every
 * <Outlet>. AppShell installs the real implementation; if a
 * component uses this outside the shell the defaults are no-ops.
 */
export type LayoutContextValue = {
  sidebarOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
};

export const LayoutContext = createContext<LayoutContextValue>({
  sidebarOpen: false,
  openSidebar: () => {},
  closeSidebar: () => {},
  toggleSidebar: () => {},
});

export function useLayout(): LayoutContextValue {
  return useContext(LayoutContext);
}
